import { PersonType } from 'enums';
import i18next from 'i18next';

export const API_SERVICES = '/services';
export const API_ALIVE = '/metadata/alive';
export const API_VERSION = '/metadata/version';
export const API_NOTIFICATIONS = '/banner';

export const API_DICTIONARY = '/public/dictionary?language={{lng}}';

export const API_ACCOUNT = '/account';

export const API_ACCOUNTS_SUMMARY = '/account/summary';
export const API_ACCOUNTS_DRAFTS = '/account/draft';
export const API_ACCOUNTS_ACTIVES = '/account/active';
export const API_ACCOUNTS_DATES = '/account/dates';
export const API_ACCOUNTS_INACTIVE = '/account/inactive';
export const API_ACCOUNTS_CSV = '/account/csv';
export const API_ACCOUNTS_REFRESH = '/advisor/account/refresh/active';
export const API_ACCOUNTS_REFRESH_INACTIVE = '/advisor/account/refresh/inactive';

export const API_LOG_LOAD_ACCOUNT = (accountId = ':accountId') => `/account/${accountId}/load`;
export const API_LOG_LOAD_ACCOUNT_USER = (accountId = ':accountId') => `/account/${accountId}/detail/load`;

export const API_ACCOUNT_CANCEL = (accountId = ':accountId') => `/account/${accountId}/cancel`;

export const API_ACCOUNT_COPY = (accountId = ':accountId') => `/account/copy/${accountId}`;

export const API_ACCOUNT_HASNOTE = (accountId = ':accountId') => `/account/${accountId}/misc/note/exists`;

export const API_ACCOUNT_NOTE = (accountId = ':accountId') => `/account/${accountId}/misc/note`;

export const API_ACCOUNT_EXPECTED_DEPOSITS = (accountId = ':accountId', period = ':period') =>
  `/account/${accountId}/expecteddeposits?period=${period}`;

export const API_ACCOUNT_EXPECTED_DEPOSIT = (accountId = ':accountId') => `/account/${accountId}/expecteddeposits`;

export const API_CLIENT_LOOKUP = (query = ':query', personType: PersonType, limit = ':limit', rep?: boolean) =>
  `/client/search?q=${query}&p=${personType}&i=${limit}${rep ? '&r=true' : ''}`;

export const API_ACCOUNT_LINK_CLIENT = (accountId = ':accountId') => `/account/${accountId}/misc/client/select`;
export const API_ACCOUNT_LINK_REP = (accountId = ':accountId') => `/account/${accountId}/misc/representative/select`;

export const API_ACCOUNT_EDIT_BASIC = (accountId = ':accountId') => `/account/${accountId}/basic`;

export const API_ACCOUNT_VARIANT = (accountId = ':accountId') => `/account/${accountId}/variant`;

export const API_ACCOUNT_ACCOUNTS = (accountId = ':accountId') => `/account/${accountId}/search`;

export const API_ACCOUNT_LINK_ACCOUNT = (accountId = ':accountId') => `/account/${accountId}/parameters`;

export const API_ACCOUNT_QUESTIONNAIRE_RESULT = (accountId = ':accountId') =>
  `/account/${accountId}/questionnaire/result`;

export const API_ACCOUNT_QUESTIONNAIRE_PROFILE = (accountId = ':accountId') =>
  `/account/${accountId}/questionnaire/profile`;

export const API_ACCOUNT_QUESTIONNAIRE_PROFILE_DETAIL = (accountId = ':accountId') =>
  `/account/${accountId}/detail/questionnaire/profile`;

export const API_ACCOUNT_QUESTIONNAIRE_CHECK = (accountId = ':accountId') =>
  `/account/${accountId}/questionnaire/check`;

export const API_ACCOUNT_QUESTIONNAIRE_SKIP = (accountId = ':accountId') => `/account/${accountId}/questionnaire/skip`;

export const API_ACCOUNT_QUESTIONNAIRE_REASON = (accountId = ':accountId') =>
  `/account/${accountId}/questionnaire/reason`;

export const API_ACCOUNT_EDIT_QUESTIONNAIRE = (accountId = ':accountId', preferEsg = '') =>
  `/account/${accountId}/questionnaire`;

export const API_ACCOUNT_EDIT_STOP = (accountId = ':accountId') => `/account/${accountId}/questionnaire/stop`;

export const API_ACCOUNT_EDIT_PLAN = (accountId = ':accountId') => `/account/${accountId}/plan`;

export const API_ACCOUNT_PLAN_PORTFOLIO = (accountId = ':accountId') => `/account/${accountId}/plan/portfolio`;

export const API_ACCOUNT_PLAN_PORTFOLIO_RECOMMENDED = (accountId = ':accountId', bucketType = ':bucketType') =>
  `/account/${accountId}/plan/portfolio/update?bucketType=${bucketType}`;

export const API_ACCOUNT_PLAN_PORTFOLIO_UPDATE = (accountId = ':accountId') =>
  `/account/${accountId}/plan/portfolio/update`;

export const API_ACCOUNT_PLAN_REBALANCING = (accountId = ':accountId') => `/account/${accountId}/plan/rebalancing`;

export const API_ACCOUNT_PLAN_REBALANCING_TIME = (accountId = ':accountId') =>
  `/account/${accountId}/plan/rebalancing/time`;

export const API_ACCOUNT_PLAN_HEDGING = (accountId = ':accountId') => `/account/${accountId}/plan/currencyhedging`;

export const API_ACCOUNT_PLAN_ENDDATE = (accountId = ':accountId') => `/account/${accountId}/plan/enddate`;

export const API_ACCOUNT_PLAN_DISPLAYDATE = (accountId = ':accountId') => `/account/${accountId}/plan/displaydate`;

export const API_ACCOUNT_PLAN_INFLATION = (accountId = ':accountId') => `/account/${accountId}/plan/inflation`;

export const API_ACCOUNT_PLAN_TOGGLE_EXTPROD = (accountId = ':accountId', productId = ':productId') =>
  `/account/${accountId}/plan/externalProduct/${productId}`;

export const API_ACCOUNT_FEES_SINGLE = (accountId = ':accountId') => `/account/${accountId}/fee/single`;

export const API_ACCOUNT_FEES_REGULAR = (accountId = ':accountId') => `/account/${accountId}/fee/regular`;

export const API_ACCOUNT_FEES_REGULAR_USETEMPLATE = (accountId = ':accountId') =>
  `/account/${accountId}/fee/regular?fromTemplate=true`;

export const API_ACCOUNT_FEES_REGULAR_SAVETEMPLATE = (accountId = ':accountId') =>
  `/account/${accountId}/fee/regular/template`;

export const API_ACCOUNT_FEES_SINGLE_MODEL = (accountId = ':accountId') => `/account/${accountId}/fee/single/model`;

export const API_ACCOUNT_FEES_REGULAR_MODEL = (accountId = ':accountId') => `/account/${accountId}/fee/regular/model`;

export const API_ACCOUNT_FEES_SPLIT = `/account/calc/fee/split`;

export const API_ACCOUNT_FEES_LIMIT = `/account/calc/fee/limit`;

export const API_ACCOUNT_FINANCE_OVERVIEW = (accountId = ':accountId') => `/account/${accountId}/finance/overview`;

export const API_ACCOUNT_FINANCE_TARGETS = (accountId = ':accountId') => `/account/${accountId}/finance/targets`;

export const API_ACCOUNT_FINANCE_TARGET = (accountId = ':accountId', targetId = ':targetId') =>
  `/account/${accountId}/finance/target/${targetId}`;

export const API_ACCOUNT_EXT_PRODUCTS = (accountId = ':accountId') => `/account/${accountId}/finance/externalProducts`;

export const API_ACCOUNT_EXT_PRODUCTS_REFRESH = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct/account`;

export const API_ACCOUNT_EXT_PRODUCTS_DOWNLOAD = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct/csv`;

export const API_ACCOUNT_EXT_PRODUCTS_TABLE_LAYOUT = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct/table/layout`;

export const API_ACCOUNT_EXT_PRODUCTS_TABLE_SORT = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct/sort`;

export const API_ACCOUNT_EXT_PRODUCT = (accountId = ':accountId', productId = ':productId') =>
  `/account/${accountId}/finance/externalProduct/${productId}`;

export const API_ACCOUNT_EXT_PRODUCT_SAVE = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct`;

export const API_ACCOUNT_EXT_PRODUCT_VALIDATE = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct?partial=true`;

export const API_ACCOUNT_EXT_PRODUCT_CALCULATE = (accountId = ':accountId', segment = ':segment') =>
  `/account/${accountId}/finance/externalProduct?segment=${segment}`;

export const API_ACCOUNT_FIN_INST_LOOKUP = (accountId = ':accountId') =>
  `/account/${accountId}/finance/externalProduct/institution`;

export const API_ACCOUNT_EXT_PRODUCT_ACCOUNTS = (accountId = ':accountId', id = ':id') =>
  `/account/${accountId}/finance/externalProduct/account${id}`;

export const API_ACCOUNT_FINANCE_SAVE_TARGET = (accountId = ':accountId') => `/account/${accountId}/finance/target`;

export const API_ACCOUNT_FINANCE_PARTNER = (accountId = ':accountId') => `/account/${accountId}/finance/partner`;

export const API_ACCOUNT_FINANCE_INCOME = (accountId = ':accountId') => `/account/${accountId}/finance/income`;

export const API_ACCOUNT_FINANCE_RETIREMENT = (accountId = ':accountId') => `/account/${accountId}/finance/retirement`;

export const API_ACCOUNT_FINANCE_RENT = (accountId = ':accountId') => `/account/${accountId}/finance/rent`;

export const API_ACCOUNT_FINANCE_RENT_RESET = (accountId = ':accountId', type = ':type') =>
  `/account/${accountId}/finance/rent?mode=${type}`;

export const API_ACCOUNT_FINANCE_RENT_RECALCULATE = (accountId = ':accountId') => `/account/${accountId}/calc/rent`;

export const API_ACCOUNT_FINANCE_RESERVE = (accountId = ':accountId', reserveId = ':reserveId') =>
  `/account/${accountId}/finance/reserve/${reserveId}`;

export const API_ACCOUNT_FINANCE_SAVE_RESERVE = (accountId = ':accountId') => `/account/${accountId}/finance/reserve`;

export const API_ACCOUNT_FINANCE_RESERVES = (accountId = ':accountId') => `/account/${accountId}/finance/reserves`;

export const API_ACCOUNT_FINANCE_DEPOSITS = (accountId = ':accountId') => `/account/${accountId}/finance/deposits`;

export const API_ACCOUNT_FINANCE_DEPOSIT_SINGLE = (accountId = ':accountId') =>
  `/account/${accountId}/finance/deposit/initial`;

export const API_ACCOUNT_FINANCE_DEPOSIT_REGULAR = (accountId = ':accountId') =>
  `/account/${accountId}/finance/deposit/periodic`;

export const API_ACCOUNT_FINANCE_DEPOSIT_EMPLOYER = (accountId = ':accountId') =>
  `/account/${accountId}/finance/deposit/employer`;

export const API_ACCOUNT_FINANCE_DEPOSIT_EMPLOYERALLOWED = (accountId = ':accountId') =>
  `/account/${accountId}/finance/deposit/employer/toggle`;

export const API_ACCOUNT_FINANCE_DEPOSIT = (accountId = ':accountId', depositId = ':depositId') =>
  `/account/${accountId}/finance/deposit/${depositId}`;

export const API_ACCOUNT_FINANCE_SAVE_DEPOSIT = (accountId = ':accountId') => `/account/${accountId}/finance/deposit`;

export const API_ACCOUNT_FINANCE_INSURANCE = (accountId = ':accountId') =>
  `/account/${accountId}/finance/retirement/insurance`;

export const API_ACCOUNT_CONTRACT_PERSONAL_DATA = (accountId = ':accountId') => `/account/${accountId}/misc/client`;

export const API_ACCOUNT_CONTRACT_PERSONAL_DATA_ID = (accountId = ':accountId', citizenship = ':citizenship') =>
  `/account/${accountId}/misc/client/idType?citizenship=${citizenship}`;

export const API_ACCOUNT_CONTRACT_PERSONAL_DATA_PERMIT = (accountId = ':accountId') =>
  `/account/${accountId}/misc/client/permit/document`;

export const API_ACCOUNT_CONTRACT_AML = (accountId = ':accountId') => `/account/${accountId}/misc/aml`;

export const API_ACCOUNT_CONTRACT_AML_OWNER = (accountId = ':accountId', ownerId = ':ownerId') =>
  `/account/${accountId}/misc/aml/owner/${ownerId}`;

export const API_ACCOUNT_CONTRACT_AML_OWNERS = (accountId = ':accountId') => `/account/${accountId}/misc/aml/owner`;

export const API_ACCOUNT_CONTRACT_AML_DOC_TYPE = (accountId = ':accountId') =>
  `/account/${accountId}/misc/aml/type/document `;

export const API_ACCOUNT_CONTRACT_AML_DOC_SOURCE = (accountId = ':accountId') =>
  `/account/${accountId}/misc/aml/source/document `;

export const API_ACCOUNT_CONTRACT_AML_DOC_PEP = (accountId = ':accountId') =>
  `/account/${accountId}/misc/aml/pep/document `;

export const API_ACCOUNT_CONTRACT_AML_DOC_PEP_LEGAL = (accountId = ':accountId', ownerId = ':ownerId') =>
  `/account/${accountId}/misc/aml/${ownerId}/pep/document `;

export const API_ACCOUNT_CONTRACT_ADDITIONAL_INFO = (accountId = ':accountId') => `/account/${accountId}/misc/data`;

export const API_ACCOUNT_SIGNATURE = (accountId = ':accountId') => `/account/${accountId}/signature`;

export const API_ACCOUNT_SIGNATURE_RESTART = (accountId = ':accountId') => `/account/${accountId}/signature/restart`;

export const API_ACCOUNT_SIGNATURE_DATA = (accountId = ':accountId') => `/account/${accountId}/signature/meta`;

export const API_ACCOUNT_COMPLETE = (accountId = ':accountId') => `/account/${accountId}/complete`;

export const API_ACCOUNT_COMPLETE_CHECK = (accountId = ':accountId', code = ':code') =>
  `/account/${accountId}/complete/check?code=${code}`;

export const API_ACCOUNT_BANKACCOUNT_SAVE = (accountId = ':accountId') => `/account/${accountId}/misc/bankaccount`;

export const API_ACCOUNT_BANKACCOUNT = (accountId = ':accountId', bankAccountId = ':bankAccountId') =>
  `/account/${accountId}/misc/bankaccount/${bankAccountId}`;

export const API_ACCOUNT_EMPLOYERS = (accountId = ':accountId') => `/account/${accountId}/misc/employer`;

export const API_ACCOUNT_EMPLOYER = (accountId = ':accountId', employerId = ':employerId') =>
  `/account/${accountId}/misc/employer/${employerId}`;

export const API_ACCOUNT_DETAIL_VARIANT = (accountId = ':accountId') => `/account/${accountId}/detail/variant`;

export const API_ACCOUNT_DETAIL_BANKACCOUNT_SAVE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/bankaccount`;

export const API_ACCOUNT_DETAIL_BANKACCOUNT_PATCH = (accountId = ':accountId') =>
  `/account/${accountId}/detail/bankaccount`;

export const API_ACCOUNT_DETAIL_BANKACCOUNT = (accountId = ':accountId', bankAccountId = ':accountId') =>
  `/account/${accountId}/detail/bankaccount/${bankAccountId}`;

export const API_ACCOUNT_DETAIL_BANKACCOUNT_PRIMARY = (accountId = ':accountId', bankAccountId = ':accountId') =>
  `/account/${accountId}/detail/bankaccount/${bankAccountId}/primary`;

export const API_ACCOUNT_DETAIL_EMPLOYERS = (accountId = ':accountId') => `/account/${accountId}/detail/employer`;

export const API_ACCOUNT_DETAIL_EMPLOYER = (accountId = ':accountId', employerId = ':employerId') =>
  `/account/${accountId}/detail/employer/${employerId}`;

export const API_ACCOUNT_DETAIL_EMPLOYER_PAYMENT = (accountId = ':accountId', companyNumber = ':companyNumber') =>
  `/account/${accountId}/pdf/employer/${companyNumber}`;

export const API_ACCOUNT_DETAIL_CREATE_DRAFT = (accountId = ':accountId') => `/account/${accountId}/detail`;

export const API_ACCOUNT_DETAIL_COMPLETE = (accountId = ':accountId', flow = ':flow', types = ':types') =>
  `/account/${accountId}/detail/change/${flow}?types=${types}`;

export const API_ACCOUNT_DETAIL_COMPLETE_CHECK = (accountId = ':accountId', code = ':code') =>
  `/account/${accountId}/detail/change/check?code=${code}`;

export const API_ACCOUNT_DETAIL_SEND_PORTAL = (accountId = ':accountId', access = ':access') =>
  `/client/${accountId}/activation/?view=${access}`;

export const API_ACCOUNT_DETAIL_REQUEST = (accountId = ':accountId') => `/account/${accountId}/signature/request`;

export const API_ACCOUNT_DETAIL_REQUEST_AMDMNT = (accountId = ':accountId') =>
  `/account/${accountId}/signature/request?type=CONTRACT_AMENDMENT`;

export const API_ACCOUNT_DETAIL_SET_2FA = (accountId = ':accountId') => `/account/${accountId}/detail/client/twofactor`;

export const API_ACCOUNT_DETAIL_SET_2FA_METHOD = (accountId = ':accountId') =>
  `/account/${accountId}/detail/client/twofactor/method`;

export const API_ACCOUNT_DETAIL_SUMMARY = (accountId = ':accountId') => `/client/${accountId}/summary`;

export const API_ACCOUNT_DETAIL_SUMMARY_ACCOUNT = (accountId = ':accountId') => `/account/${accountId}/detail/summary`;

export const API_ACCOUNT_DETAIL_RESERVES = (accountId = ':accountId') => `/account/${accountId}/detail/reserves`;

export const API_ACCOUNT_DETAIL_DEPOSITS = (accountId = ':accountId') => `/account/${accountId}/detail/deposits`;

export const API_ACCOUNT_DETAIL_DEPOSIT_SINGLE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/deposit/initial`;

export const API_ACCOUNT_DETAIL_DEPOSIT_REGULAR = (accountId = ':accountId') =>
  `/account/${accountId}/detail/deposit/periodic`;

export const API_ACCOUNT_DETAIL_DEPOSIT_REGULAR_CALC = (accountId = ':accountId') =>
  `/account/${accountId}/calc/deposit`;

export const API_ACCOUNT_DETAIL_DEPOSIT_EMPLOYER = (accountId = ':accountId') =>
  `/account/${accountId}/detail/deposit/employer`;

export const API_ACCOUNT_DETAIL_DEPOSIT_EMPLOYERALLOWED = (accountId = ':accountId') =>
  `/account/${accountId}/detail/deposit/employer/toggle`;

export const API_ACCOUNT_DETAIL_DEPOSIT = (accountId = ':accountId', depositId = ':depositId') =>
  `/account/${accountId}/detail/deposit/${depositId}`;

export const API_ACCOUNT_DETAIL_SAVE_DEPOSIT = (accountId = ':accountId') => `/account/${accountId}/detail/deposit`;

export const API_ACCOUNT_DETAIL_RESERVE = (accountId = ':accountId', reserveId = ':reserveId') =>
  `/account/${accountId}/detail/reserve/${reserveId}`;

export const API_ACCOUNT_DETAIL_SAVE_RESERVE = (accountId = ':accountId') => `/account/${accountId}/detail/reserve`;

export const API_ACCOUNT_DETAIL_FINANCE_PARTNER = (accountId = ':accountId') => `/account/${accountId}/detail/partner`;

export const API_ACCOUNT_DETAIL_FINANCE_INCOME = (accountId = ':accountId') => `/account/${accountId}/detail/income`;

export const API_ACCOUNT_DETAIL_FINANCE_INSURANCE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/retirement/insurance`;

export const API_ACCOUNT_DETAIL_FINANCE_RETIREMENT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/retirement`;

export const API_ACCOUNT_DETAIL_RENT = (accountId = ':accountId') => `/account/${accountId}/detail/rent`;

export const API_ACCOUNT_DETAIL_FINANCE_RENT_RESET = (accountId = ':accountId', type = ':type') =>
  `/account/${accountId}/detail/rent?mode=${type}`;

export const API_ACCOUNT_DETAIL_TARGET = (accountId = ':accountId', targetId = ':targetId') =>
  `/account/${accountId}/detail/target/${targetId}`;

export const API_ACCOUNT_DETAIL_SAVE_TARGET = (accountId = ':accountId') => `/account/${accountId}/detail/target`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCTS = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProducts`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCTS_REFRESH = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct/account`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCTS_DOWNLOAD = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct/csv`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCTS_TABLE_LAYOUT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct/table/layout`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCTS_TABLE_SORT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct/sort`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCT = (accountId = ':accountId', productId = ':productId') =>
  `/account/${accountId}/detail/externalProduct/${productId}`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCT_SAVE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCT_VALIDATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct?partial=true`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCT_CALCULATE = (accountId = ':accountId', segment = ':segment') =>
  `/account/${accountId}/detail/externalProduct?segment=${segment}`;

export const API_ACCOUNT_DETAIL_FIN_INST_LOOKUP = (accountId = ':accountId') =>
  `/account/${accountId}/detail/externalProduct/institution`;

export const API_ACCOUNT_DETAIL_EXT_PRODUCT_ACCOUNTS = (accountId = ':accountId', id = ':id') =>
  `/account/${accountId}/detail/externalProduct/account${id}`;

export const API_ACCOUNT_DETAIL_PLAN = (accountId = ':accountId') => `/account/${accountId}/detail/plan`;

export const API_ACCOUNT_DETAIL_PLAN_PORTFOLIO = (accountId = ':accountId') => `/account/${accountId}/detail/portfolio`;

export const API_ACCOUNT_DETAIL_PLAN_PORTFOLIO_RECOMMENDED = (accountId = ':accountId', bucketType = ':bucketType') =>
  `/account/${accountId}/detail/portfolio/update?bucketType=${bucketType}`;

export const API_ACCOUNT_DETAIL_PLAN_PORTFOLIO_UPDATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/portfolio/update`;

export const API_ACCOUNT_DETAIL_PLAN_HISTORY = (accountId = ':accountId') =>
  `/account/${accountId}/detail/plan/?original=true`;

export const API_ACCOUNT_DETAIL_PLAN_REBALANCING = (accountId = ':accountId') =>
  `/account/${accountId}/detail/rebalancing`;

export const API_ACCOUNT_DETAIL_PLAN_REBALANCING_TIME = (accountId = ':accountId') =>
  `/account/${accountId}/detail/rebalancing/time`;

export const API_ACCOUNT_DETAIL_PLAN_ONETIMEREBALANCE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/onetimerebalance`;

export const API_ACCOUNT_DETAIL_PLAN_HEDGING = (accountId = ':accountId') =>
  `/account/${accountId}/detail/currencyhedging`;

export const API_ACCOUNT_DETAIL_PLAN_ENDDATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/plan/enddate`;

export const API_ACCOUNT_DETAIL_PLAN_DISPLAYDATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/plan/displaydate`;

export const API_ACCOUNT_DETAIL_PLAN_INFLATION = (accountId = ':accountId') =>
  `/account/${accountId}/detail/plan/inflation`;

export const API_ACCOUNT_DETAIL_PLAN_TOGGLE_EXTPROD = (accountId = ':accountId', productId = ':productId') =>
  `/account/${accountId}/detail/externalProduct/${productId}`;

export const API_ACCOUNT_DETAIL_QUESTIONNAIRE_RESULT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/questionnaire/result`;

export const API_ACCOUNT_DETAIL_EDIT_QUESTIONNAIRE = (accountId = ':accountId', preferEsg = '') =>
  `/account/${accountId}/detail/questionnaire${preferEsg}`;

export const API_ACCOUNT_DETAIL_QUESTIONNAIRE_CHECK = (accountId = ':accountId') =>
  `/account/${accountId}/detail/questionnaire/check`;

export const API_ACCOUNT_DETAIL_QUESTIONNAIRE_REASON = (accountId = ':accountId') =>
  `/account/${accountId}/detail/questionnaire/reason`;

export const API_ACCOUNT_DETAIL_EDIT_STOP = (accountId = ':accountId') =>
  `/account/${accountId}/detail/questionnaire/stop`;

export const API_ACCOUNT_DETAIL_DEPOSIT_INSTRUCTIONS = (accountId = ':accountId') =>
  `/account/${accountId}/detail/deposit/instruction`;

export const API_ACCOUNT_DETAIL_WITHDRAWAL_CREATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw`;

export const API_ACCOUNT_DETAIL_WITHDRAWAL = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw/basic`;

export const API_ACCOUNT_DETAIL_WITHDRAWAL_ADJUSTMENT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw/adjust`;

export const API_ACCOUNT_DETAIL_TRANSFER_BASIC = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/basic`;

export const API_ACCOUNT_DETAIL_TRANSFER_ADJUSTMENT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/adjust`;

export const API_ACCOUNT_DETAIL_TRANSFER_OVERVIEW = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/overview`;

export const API_ACCOUNT_DETAIL_TRANSFER_MODEL = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/model`;

export const API_ACCOUNT_DETAIL_HISTORY = (accountId = ':accountId', period = ':period') =>
  `/account/${accountId}/detail/history?period=${period}`;

export const API_ACCOUNT_DETAIL_CHANGE = (accountId = ':accountId') => `/account/${accountId}/detail/change`;

export const API_ACCOUNT_DETAIL_CHECK_SIGNING = (accountId = ':accountId') =>
  `/account/${accountId}/detail/change/signature`;

export const API_ACCOUNT_DETAIL_SUMMARIES = (accountId = ':accountId') => `/account/${accountId}/detail/statement/ocp`;

export const API_ACCOUNT_DETAIL_REPORTS = (accountId = ':accountId') =>
  `/account/${accountId}/detail/statement/periodical`;

export const API_ACCOUNT_DETAIL_REPORT_REQUEST = (accountId = ':accountId') =>
  `/account/${accountId}/detail/statement/periodical/request`;

export const API_ACCOUNT_DETAIL_DOWNLOAD_STATEMENT = (accountId = ':accountId', documentId = ':documentId') =>
  `/account/${accountId}/pdf/download/${documentId}`;

export const API_ACCOUNT_DETAIL_DOWNLOAD_PERIODICAL_STATEMENT = (
  accountId = ':accountId',
  documentId = ':documentId',
) => `/account/${accountId}/detail/statement/periodical/${documentId}/download`;

export const API_ACCOUNT_DETAIL_MOVEMENTS = (accountId = ':accountId') => `/account/${accountId}/detail/movements`;

export const API_ACCOUNT_DETAIL_MOVEMENTS_CSV = (accountId = ':accountId') =>
  `/account/${accountId}/detail/movements/csv`;

export const API_ACCOUNT_DETAIL_FEES_CREATE = (accountId = ':accountId') => `/account/${accountId}/detail/fee`;

export const API_ACCOUNT_DETAIL_FEES_SINGLE = (accountId = ':accountId') => `/account/${accountId}/detail/fee/single`;

export const API_ACCOUNT_DETAIL_FEES_REGULAR = (accountId = ':accountId') => `/account/${accountId}/detail/fee/regular`;

export const API_ACCOUNT_DETAIL_FEES_REGULAR_USETEMPLATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/fee/regular?fromTemplate=true`;

export const API_ACCOUNT_DETAIL_FEES_REGULAR_SAVETEMPLATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/fee/regular/template`;

export const API_ACCOUNT_DETAIL_FEES_SINGLE_MODEL = (accountId = ':accountId') =>
  `/account/${accountId}/detail/fee/single/model`;

export const API_ACCOUNT_DETAIL_FEES_REGULAR_MODEL = (accountId = ':accountId') =>
  `/account/${accountId}/detail/fee/regular/model`;

export const API_ACCOUNT_DETAIL_SIGNED_DOCUMENTS = (accountId = ':accountId') =>
  `/account/${accountId}/detail/document`;

export const API_ACCOUNT_DETAIL_PERSONAL_DATA_PERMIT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/client/permit/document`;

export const API_ACCOUNT_DETAIL_OVERVIEW = (accountId = ':accountId') => `/account/${accountId}/detail/overview`;

export const API_ACCOUNT_WITHDRAW_TARGET = (accountId = ':accountId', targetId = ':targetId') =>
  `/account/${accountId}/detail/withdraw/adjust/target/${targetId}`;

export const API_ACCOUNT_TRANSFER_TARGET = (accountId = ':accountId', targetId = ':targetId') =>
  `/account/${accountId}/detail/transfer/adjust/target/${targetId}`;

export const API_ACCOUNT_WITHDRAW_SAVE_TARGET = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw/adjust/target`;

export const API_ACCOUNT_TRANSFER_SAVE_TARGET = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/adjust/target`;

export const API_ACCOUNT_WITHDRAW_RESERVE = (accountId = ':accountId', reserveId = ':reserveId') =>
  `/account/${accountId}/detail/withdraw/adjust/reserve/${reserveId}`;

export const API_ACCOUNT_TRANSFER_RESERVE = (accountId = ':accountId', reserveId = ':reserveId') =>
  `/account/${accountId}/detail/transfer/adjust/reserve/${reserveId}`;

export const API_ACCOUNT_WITHDRAW_SAVE_RESERVE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw/adjust/reserve`;

export const API_ACCOUNT_TRANSFER_SAVE_RESERVE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/adjust/reserve`;

export const API_ACCOUNT_WITHDRAW_DEPOSIT = (accountId = ':accountId', depositId = ':depositId') =>
  `/account/${accountId}/detail/withdraw/adjust/deposit/${depositId}`;

export const API_ACCOUNT_TRANSFER_DEPOSIT = (accountId = ':accountId', depositId = ':depositId') =>
  `/account/${accountId}/detail/transfer/adjust/deposit/${depositId}`;

export const API_ACCOUNT_WITHDRAW_SAVE_DEPOSIT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/withdraw/adjust/deposit`;

export const API_ACCOUNT_TRANSFER_SAVE_DEPOSIT = (accountId = ':accountId') =>
  `/account/${accountId}/detail/transfer/adjust/deposit`;

export const API_ACCOUNT_DETAIL_CLIENT = (accountId = ':accountId') => `/account/${accountId}/detail/client`;

export const API_ACCOUNT_DETAIL_TRANSFER = (accountId = ':accountId') => `/account/${accountId}/detail/transfer`;

export const API_ACCOUNT_DETAIL_CLIENT_NOTIFICATION = (accountId = ':accountId') =>
  `/account/${accountId}/detail/client/notification`;

export const API_ACCOUNT_DETAIL_TERMINATE = (accountId = ':accountId') =>
  `/account/${accountId}/detail/requestTermination`;

export const API_ACCOUNT_VALIDATION_NUMBER = (accountId = ':accountId') =>
  `/account/${accountId}/misc/document/validation/number`;

export const API_ACCOUNT_VALIDATION_DATE = (accountId = ':accountId') =>
  `/account/${accountId}/misc/document/validation/date`;

export const API_ACCOUNT_DOWNLOAD_PLAN = (accountId = ':accountId') => `/account/${accountId}/pdf/INVESTMENT_PLAN`;

export const API_ACCOUNT_DOWNLOAD_OVERVIEW = (accountId = ':accountId') => `/account/${accountId}/pdf/DRAFT_OVERVIEW`;

export const API_ACCOUNT_DOWNLOAD_DETAIL_PLAN = (accountId = ':accountId') =>
  `/account/${accountId}/pdf/DETAIL_INVESTMENT_PLAN`;

export const API_ACCOUNT_DOWNLOAD_CHANGED_PLAN = (accountId = ':accountId') =>
  `/account/${accountId}/pdf/change/INVESTMENT_PLAN`;

export const API_ACCOUNT_IMP = (accountId = ':accountId', bucket = ':bucket') =>
  `/account/${accountId}/portfolio/imp/${bucket}`;

export const API_ACCOUNT_DETAIL_IMP = (accountId = ':accountId', bucket = ':bucket') =>
  `/account/${accountId}/detail/portfolio/imp/${bucket}`;

export const API_ACCOUNT_COMMISSIONS = (accountId = ':accountId') => `/account/${accountId}/commission`;

export const API_ACCOUNT_CALC_INCOME = '/account/calc/income';

export const API_ASSET_CHART = (woodId = ':woodId', period = ':period') =>
  `/product/${woodId}/history${period ? '?period=' + period : ''}`;

// FIXME: universal string param def
export type API_FUNCTION_TYPE = (accountId?: string) => string;
export type API_FUNCTION_TYPE_TARGET = (accountId?: string, targetId?: string) => string;
export type API_FUNCTION_TYPE_DEPOSIT = (accountId?: string, depositId?: string) => string;
export type API_FUNCTION_TYPE_BANKACCOUNT = (accountId?: string, bankAccountId?: string) => string;
export type API_FUNCTION_TYPE_IMP = (accountId?: string, bucket?: string) => string;

export type API_FUNCTION_TYPE_ID = (accountId?: string, id?: string) => string;

export const ADVISOR_RANKINGS = (period = ':period', sortBy = ':sortBy') =>
  `/advisor/ranking?period=${period}&sortBy=${sortBy}`;
export const ADVISOR_TRADING_DAY = '/advisor/tradingday';
export const ADVISOR_LOGO = '/advisor/logo';
export const ADVISOR_LOGO_FORCE = `/advisor/logo/?force=true`;

export const ADMIN_TRADING_DAY = '/robo/tradingday';
export const ADMIN_ORDERS_EXCLUDE_WITHDRAWAL = '/robo/orders/exclude/target/withdrawal';
export const ADMIN_ORDERS_EXCLUDE_TRANSFER = '/robo/orders/exclude/transfer';
export const ADMIN_ORDERS_EXCLUDE_FEE = '/robo/orders/exclude/fee';
export const ADMIN_ORDERS_EXECUTE_WITHDRAWAL = '/robo/orders/execute/target/withdrawal';
export const ADMIN_ORDERS_EXECUTE_TRANSFER = '/robo/orders/execute/transfer';
export const ADMIN_ORDERS_EXECUTE_FEE = '/robo/orders/execute/fee';
export const ADMIN_ORDERS_WITHDRAWAL = '/robo/orders/target/withdrawal';
export const ADMIN_ORDERS_TRANSFER = '/robo/orders/transfer';
export const ADMIN_ORDERS_FEE = '/robo/orders/fee';
export const ADMIN_COMMISSION = '/robo/commission';
export const ADMIN_ACCOUNTS = '/admin/accounts/csv';
export const ADMIN_ACCOUNTS_SIMPLE = '/bo/accounts/csv';
export const ADMIN_ACCOUNT_TRANSACTION = (accountId = 'accountId') => `/bo/account/${accountId}/transaction`;
export const ADMIN_UNPROCESSED_TRANSFERS = '/robo/orders/unprocessed';
export const ADMIN_CONSTANTS = '/admin/constants';
export const ADMIN_SERVICES = '/bo/service/unavailability';
export const ADMIN_NOTIFICATIONS = '/bo/banner';
export const ADMIN_NOTIFICATIONS_DELETE = (id = ':id') => `/bo/banner/${id}`;
export const ADMIN_INSTITUTIONS = '/bo/financialInstitution';
export const ADMIN_INSTITUTION = (id = ':id') => `/bo/financialInstitution/${id}`;
export const ADMIN_IMPORT_USERS = '/bo/users/import';
export const ADMIN_IMPORT_PARTNERS = '/bo/partners/import';
export const ADMIN_IMPORT_FUNDS = '/admin/funds/import';
export const ADMIN_IMPORT_ORDERS = '/admin/orders/import';
export const ADMIN_IMPORT_PORTFOLIO = (
  type: ':type',
  currency: ':currency',
  hedgingEur: ':hedging',
  hedgingUsd: ':hedging',
) => `/admin/portfolio/import/${type}/?currency=${currency}&hedgingEur=${hedgingEur}&hedgingUsd=${hedgingUsd}`;
export const ADMIN_OPTIONS = `/bo/options`;
export const ADMIN_ACCOUNT_EVENTS = (accountId = ':accountId') => `/bo/account/${accountId}/event`;
export const ADMIN_DELETE_ACCOUNT = (accountId = ':accountId') => `/bo/account/${accountId}`;
export const ADMIN_ACTIVATE_ACCOUNT = (accountId = ':accountId') => `/admin/account/${accountId}`;
export const ADMIN_GENERATE_PDF = (accountId = ':accountId', type = ':type', change: boolean) =>
  `/bo/account/${accountId}/document/render/${type}?change=${change}`;
export const ADMIN_GENERATE_BOPO_PDF = (bopoId = ':bopoId', type = ':type', filename = ':filename') =>
  `/bo/bopo/${bopoId}/download/${type}?filename=${
    filename || 'bopo_' + bopoId + '_' + i18next.t(`pdf_document_${type}`) + '.pdf'
  }`;
export const ADMIN_GENERATE_AMENDMENT = (accountId = ':accountId') => `/bo/account/${accountId}/amendment`;
export const ADMIN_GENERATE_CSV = (accountId = ':accountId') => `/bo/distribution/${accountId}/csv`;
export const ADMIN_SIGNATURE = (accountId = ':accountId') => `/bo/account/${accountId}/signature`;
export const ADMIN_TERMINATION = (accountId = ':accountId') => `/bo/account/${accountId}/request/signature`;
export const ADMIN_CHANGE_PHONE = (accountId = ':accountId') => `/bo/account/${accountId}/phone`;
export const ADMIN_CHANGE_EMAIL = (accountId = ':accountId') => `/bo/account/${accountId}/email`;
export const ADMIN_CHANGE_TAXMODE = (identifier = ':identifier') => `/bo/client/${identifier}/tax`;
export const ADMIN_CHANGE_2FA = (email = ':email') => `/bo/user/endusers/${email}/twofactor`;
export const ADMIN_REACTIVATE_USER = `/bo/user/enduser/enable`;
export const ADMIN_CHANGE_CLAIM = (accountId = ':accountId') => `/bo/account/${accountId}/claim`;
export const ADMIN_SEND_EVENT = (accountId = ':accountId') => `/bo/account/${accountId}/event`;
export const ADMIN_CHANGE_CC = (accountId = ':accountId') => `/bo/account/${accountId}/clientcard`;
export const ADMIN_TRANSFER_CC = `/bo/account/clientcards`;
export const ADMIN_CHANGE_ID = (accountId = ':accountId') => `/bo/account/${accountId}/identifier`;
export const ADMIN_FIND_ERROR = (occurenceId = ':occurenceId') => `/bo/error/${occurenceId}`;
export const ADMIN_SIGNED_DOCUMENTS = (accountId = ':accountId') => `/bo/account/${accountId}/document`;
export const ADMIN_ADVISORS = '/bo/user/advisor';
export const ADMIN_ADVISOR_ACCOUNTS = (realm = ':realm', userName = ':userName') =>
  `/bo/user/advisor/${realm}/${userName}/account`;
export const ADMIN_ADVISOR_ACTIVATE = (realm = ':realm', userName = ':userName') =>
  `/bo/user/advisor/${realm}/${userName}/reactivate`;
export const ADMIN_ADVISOR_IND = (realm = ':realm', username = ':username') =>
  `/bo/user/advisor/${realm}/${username}/portfolio`;
export const ADMIN_ADVISOR = (realm = ':realm', userName = ':userName') => `/bo/user/advisor/${realm}/${userName}`;
export const ADMIN_ADVISOR_CHANGE_PHONE = (accountId = ':accountId') => `/bo/account/${accountId}/representative/phone`;
export const ADMIN_ADVISOR_CHANGE_EMAIL = (accountId = ':accountId') => `/bo/account/${accountId}/representative/email`;
export const ADMIN_SET_PARTNERCODE = (realm = ':realm', userName = ':userName') => `/bo/partner/${realm}/${userName}`;
export const ADMIN_ADVISOR_TRANSFER = (realm = ':realm', userName = ':userName') =>
  `/bo/user/advisor/${realm}/${userName}/transfer`;
export const API_PORTFOLIO = '/portfolio/template';
export const API_PORTFOLIO_DETAIL = (id = ':id') => `/portfolio/template/${id}`;
export const API_PORTFOLIO_ASSETS = (id = ':id') => `/portfolio/template/${id}/assets`;
export const API_PORTFOLIO_ASSETS_DRAFT = (id = ':id') => `/portfolio/template/${id}/assets/draft`;
export const API_PORTFOLIO_UPDATE = (id = ':id') => `/portfolio/template/${id}/status`;
export const API_PORTFOLIO_EXECUTE = `/portfolio/template/execute`;
export const ADMIN_USER_PORTFOLIOS = '/admin/portfolio/custom';
export const ADMIN_DOWNLOAD_PORTFOLIOS = '/bo/portfolio/csv';
export const ADMIN_INSTRUMENTS = (intermediary = ':intermediary') => `/admin/funds/${intermediary}`;
export const ADMIN_DELETE_STATEMENT = (accountId = ':accountId') => `/bo/account/${accountId}/report`;
/*
export const API_DOCUMENT = (accountId = ':accountId', type = ':type') => `/account/${accountId}/pdf/template/${type}`;
export const API_DOCUMENT_DATE = (accountId = ':accountId', type = ':type', date = ':date') =>
  `/account/${accountId}/pdf/template/${type}/${date}`;
*/
export const API_STATEMENT_PDF_DATA = (accountId = ':accountId', id = ':id') =>
  `/account/${accountId}/pdf/preview/statement/${id}`;
export const API_CLIENT_DATA = '/overview';
export const API_CLIENT_DATA_SIGN = '/account/sign';
export const API_CLIENT_SIGN_DOCUMENTS_LIST = (accountId = ':accountId') => `/account/${accountId}/sign/document`;
export const API_CLIENT_SIGN_REQUESTS_LIST = `/request`;
export const API_CLIENT_SIGN_BUCKET = (accountId = ':accountId') => `/account/${accountId}/sign/bucket`;
export const API_CLIENT_SIGN_PORTFOLIO = (accountId = ':accountId') => `/account/${accountId}/sign/portfolio`;

export const API_CLIENT_SIGN_PDF_DATA = (accountId = ':accountId', templateType = ':templateType', change = ':false') =>
  `/account/${accountId}/sign/template/${templateType}?change=${change}`;
export const API_CLIENT_SIGN_PDF_FILE = (accountId = ':accountId', templateType = ':templateType', change = ':false') =>
  `/account/${accountId}/sign/pdf/${templateType}?change=${change}`;

export const API_CLIENT_REQUEST_PDF_DATA = (requestId = ':requestId') => `/request/pdf/template/${requestId}`;
export const API_CLIENT_REQUEST_PDF_FILE = (requestId = ':requestId') => `/request/pdf/${requestId}`;

export const API_CLIENT_SIGN_CONFIRM_DOCUMENT = (
  accountId = ':accountId',
  templateType = ':templateType',
  change = ':false',
) => `/account/${accountId}/sign/document/${templateType}?change=${change}`;
export const API_CLIENT_SIGN_REQUEST_SMS = (accountId = ':accountId') => `/account/${accountId}/sign/request`;
export const API_CLIENT_SIGN_VERIFY_SMS = (accountId = ':accountId') => `/account/${accountId}/sign/verify`;
export const API_CLIENT_SIGN_ABORT = (accountId = ':accountId') => `/account/${accountId}/sign/cancel`;
export const API_CLIENT_SIGN_REQUEST = (requestId = ':requestId') => `/request/${requestId}`;
//export const API_CLIENT_SIGN_SETTINGS = (accountId = ':accountId') => `/account/${accountId}/settings`;

export const API_MAX_LOGIN_LENGTH = '/users/maxLoginLength';

export const COMMON_ENDPOINTS = [API_DICTIONARY, API_VERSION, API_NOTIFICATIONS, API_SERVICES, API_MAX_LOGIN_LENGTH]; // same for advisors & endusers
export const NON_VERSIONED_ENDPOINTS = [API_ALIVE, API_VERSION];
export const AUTO_ENDPOINTS = [API_NOTIFICATIONS, API_SERVICES];
